import Vue from 'vue'
import router from './router'
import store from './store'

// 1. 引入 Element 及官方主题样式
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 2. 一次性全局注册所有组件
Vue.use(ElementUI)

// import HomePage from '@/pages/HomePage.vue'
import App from '@/pages/App.vue'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

